import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricClicksGhaPPA extends MetricBase {
    constructor() {
        super({
            field: "metric_clicks",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads_ppa.clicks.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads_ppa.clicks.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads_ppa.clicks.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricClicksGhaPPA;
